import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { serviceurl } from 'src/app/constant/constant';
import { TokenPack } from '../../shared/token-credit-modal/model/token-credit.model';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {
  private apiUrl = serviceurl + 'api/subscriptions';

  constructor(private http: HttpClient) { }

  getSubscriptionByIdForUsage(id: number | string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/usage/${id}/`);
  }

  getCurrentSubscription(userId: number | string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/current-subscription/${userId}/`);
  }

  verifyEmail(userId: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/verify-email/`, { user_id: userId });
  }


  redirectToCustomPortal(userID: string | number) {
    return this.http.post<any>(`${this.apiUrl}/stripe/customer-portal/`, { user_id: userID });
  }

  getCustomerSession(userId: number | string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/customer-session/${userId}/`);
  }

  getSubscriptionPlans(userId?: number | string): Observable<any> {
    const url = userId 
      ? `${this.apiUrl}/plans/?user_id=${userId}`
      : `${this.apiUrl}/plans/`;
    return this.http.get<any>(url);
  }

  getStripeProducts(): Observable<{ token_packs: TokenPack[] }> {
    return this.http.get<{ token_packs: TokenPack[] }>(`${serviceurl}api/tokens/token-packs/`);
  }


  createCheckoutSession(userId: number | string, planId: number | null, priceId?: string): Observable<any> {
    const payload: any = {
      user_id: userId
    };
    
    if (priceId) {
      payload.price_id = priceId;
    } else if (planId) {
      payload.plan_id = planId;
    }
    
    return this.http.post<any>(`${this.apiUrl}/checkout-session/`, payload);
  }

  createTokenPackCheckoutSession(userId: number | string, tokenPackId: number, queryParams?: string): Observable<any> {
    const baseUrl = `${serviceurl}api/tokens/token-packs/checkout/`;
    const url = queryParams ? `${baseUrl}?${queryParams}` : baseUrl;
    return this.http.post<any>(url, {
      user_id: userId,
      token_pack_id: tokenPackId
    });
  }
}